import { Page } from '@app/components/page/Page';
import { StationGroupsIcon } from '@app/components/stations/StationGroupsIcon';
import { capitalizeFirst } from '@mi-front/core';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { StationGroupsBreadcrumbs } from '../header';
import { useStationGroupQuery } from '../hooks/useStationGroupQuery';
import { stationGroupsMessages } from '../station-groups-messages';
import { StationGroupInfo } from './StationGroupInfo';

/** Admin station group detail page (read-only). */
export function AdminStationGroupsViewPage() {
  const { id } = useParams<{ id: string }>();
  const { $t } = useIntl();
  const groupQuery = useStationGroupQuery(id);

  return (
    <QueryView query={groupQuery}>
      {(group) => (
        <Page
          data-cy="station-groups-view-screen"
          htmlTitle={`${capitalizeFirst($t(stationGroupsMessages.breadcrumb))} ${group.name}`}
        >
          <Page.Header
            icon={<StationGroupsIcon />}
            title={group.name}
            breadcrumbs={<StationGroupsBreadcrumbs activeText={group.name} />}
          />
          <Page.Content>
            <StationGroupInfo group={group} />
          </Page.Content>
        </Page>
      )}
    </QueryView>
  );
}
